import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../../Art57Node/Art57Node";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { TreeNodeDrugIngredientEntity } from "../Entity/TreeNodeDrugIngredientEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductsDrugIngredientsList extends Art57NodeList {
    constructor(injector: Injector, parent: BaseNode) {
      super(injector, new ListView(), 'Drug Ingredients ({param})');
      this.parent = parent;
      this.labelNodeName = 'Drug Ingredients';
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
      if (this.parent) {
        (this.parent as Art57Node).refreshLabel();
      }
    }
  
    override createChildTemplate(params: any): Art57Node[] | null {
      let node = new TreeNodeDrugIngredientEntity(this.ioc!, this);
      if (params && params.roleofingredient) {
        node.data.model = { ...node.data.model, roleofingredient: params.roleofingredient } ;
      } 
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
        
    override getHeaders(): string[] {
      return ['EV Code', 'Substance', 'Role of Ingredient', 'Amount Value Type',  
              'Numerator Value (Low Limit)', 'Numerator Prefix (Low Limit)', 'Numerator Unit (Low Limit)', 
              'Denominator Value (Low Limit)', 'Denominator Prefix (Low Limit)', 'Denominator Unit (Low Limit)', 
              'Numerator Value (High Limit)', 'Numerator Prefix (High Limit)', 'Numerator Unit (High Limit)', 
              'Denominator Value (High Limit)', 'Denominator Prefix (High Limit)', 'Denominator Unit (High Limit)'
             ];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsDrugIngredientsList = new TreeNodeMedicinalProductsDrugIngredientsList(this.ioc!,newParent);      

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
// property doesn't exist      clonedNode.cloningNode = false;
      return clonedNode;
    }

  }